/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "DeactivateTeamMemberRequest": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "lastDateOfEmployment": {
                "type": ".squareup.common.time.YearMonthDay",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DeactivateTeamMemberResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.DeactivateTeamMemberRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.DeactivateTeamMemberResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a request to deactivate a team member.
 * --
 *
 * SOURCE DeactivateTeamMemberRequest @ squareup/team_api/endpoints/deactivate-team-member.proto at 22:1
 */
export const DeactivateTeamMemberRequest = $root.lookupType('squareup.team_api.DeactivateTeamMemberRequest');
fixType(DeactivateTeamMemberRequest);
Builder.createAndAttachToType(DeactivateTeamMemberRequest);
/**
 * --
 * @desc Represents a response to deactivating a team member.
 * --
 *
 * SOURCE DeactivateTeamMemberResponse @ squareup/team_api/endpoints/deactivate-team-member.proto at 40:1
 */
export const DeactivateTeamMemberResponse = $root.lookupType('squareup.team_api.DeactivateTeamMemberResponse');
fixType(DeactivateTeamMemberResponse);
Builder.createAndAttachToType(DeactivateTeamMemberResponse);